import { StaticBody } from '../../../common/enums/enums';
import { getGroupedFiltersForVehicle } from '../../../redux/actions/workQueue/allOrdersActions';
import { selectDoneFilters } from '../../../redux/selectors/orders/doneOrdersSelector';
import { selectMyOrdersFilters } from '../../../redux/selectors/orders/myOrdersSelectors';
import { selectAllOrdersFiltersByCompany } from '../../../redux/selectors/workQueue/allOrdersSelectors';

export const filterCleanup = fullFilters => {
  const obj = { ...fullFilters };
  obj.dateRange = fullFilters.dateRange?.formattedDate;
  return obj;
};
export const SELECTORS_BY_TAB = {
  AllOrders: {
    body: selectAllOrdersFiltersByCompany,
    emptyTitle: 'global:noWO',
    emptySubTitle: 'global:noWOAllOrders',
    enableEditRo: true,
    isSortEnabled: true,
    enableStatusColumn: true,
  },
  MyOrders: {
    body: selectMyOrdersFilters,
    emptyTitle: 'global:noWO',
    emptySubTitle: 'global:noWOMyOrders',
    isSortEnabled: false,
    enableStatusColumn: true,
  },
  DoneOrders: {
    body: selectDoneFilters,
    emptyTitle: 'global:noWO',
    emptySubTitle: 'global:noWOAllOrders',
    enableExportWO: true,
    enableEditRo: true,
    isSortEnabled: false,
    enableStatusColumn: false,
  },
};

export const BODY_BUILDER_BY_TAB = {
  AllOrders: (
    companyId,
    pageNumber,
    filters,
    optionalSearchQuery,
    sortEnabled = false,
    sortBy,
    fieldValue
  ) => {
    const groupedFilters = getGroupedFiltersForVehicle(
      companyId,
      filterCleanup(filters),
      false
    );

    const staticBody = StaticBody.workQueue.allOrders(
      sortEnabled,
      sortBy,
      fieldValue
    );
    return {
      ...staticBody,
      searchQuery: filters.searchQuery,
      pageNumber,
      groupedFilters,
      filters: [],
    };
  },
  MyOrders: (companyId, pageNumber, filters, searchQuery) => {
    const staticBody = StaticBody.orders.myOrders;
    return {
      ...staticBody,
      searchQuery,
      pageNumber,
      filters: [
        { column: 'ownerIds', value: [filters.personId], operator: 'eq' },
        { column: 'dealershipId', value: companyId, operator: 'eq' },
      ],
    };
  },
  DoneOrders: (companyId, pageNumber, filters) => {
    const groupedFilters = getGroupedFiltersForVehicle(
      companyId,
      filterCleanup(filters),
      true
    );
    const staticBody = StaticBody.workQueue.done;
    return {
      ...staticBody,
      searchQuery: filters.searchQuery,
      pageNumber,
      groupedFilters,
      filters: [],
    };
  },
};
